export const BasicOverlayMixin = (superClass) =>
  class BasicOverlayMixin extends superClass {
    static get properties() {
      return {
        /* DOM node that triggers the overlay (button, menu-item) */
        _invokerNode: { type: Object },
        /* node that is used for relative positioning */
        _attachNode: { type: Object },
      };
    }
    constructor() {
      super();
      this._rootNodes = [];
    }
    connectedCallback() {
      super.connectedCallback();
      this._onParentScroll = this._parentScrollActions.bind(this);
      this._windowResizeListener = this._windowResizeActions.bind(this);
      this._resizeObserverCallback = this._resizeObserverActions.bind(this);
      this._resizeObserver = new ResizeObserver(this._resizeObserverCallback);
    }
    updated(changedProperties) {
      super.updated(changedProperties);
      if (changedProperties.has('_invokerNode')) {
        const oldInvokerNode = changedProperties.get('_invokerNode');
        const hasOldInvokerNodeValue = Boolean(oldInvokerNode);
        if (hasOldInvokerNodeValue) {
          this._doSomethingWithOldInvokerNode(oldInvokerNode);
        }
        if (this._invokerNode) {
          this._doSomethingWithNewInvokerNode(this._invokerNode);
        }
      }
      if (changedProperties.has('_attachNode')) {
        this._removeScrollResizeObservers(null, true, false, true);
        const oldAttachNode = changedProperties.get('_attachNode');
        const hasOldAttachNode = Boolean(oldAttachNode);
        if (hasOldAttachNode) {
          this._removeScrollResizeObservers(oldAttachNode, false, true, false);
        }
        this._setOverlayPositionIfPossible();
      }
      if (changedProperties.has('visible')) {
        this._removeScrollResizeObservers();
        this._setOverlayPositionIfPossible();
      }
    }
    _setOverlayPositionIfPossible() {
      if (this.visible && this._attachNode) {
        this._addScrollResizeObservers();
        if (this._canPositionOverlay()) {
          this._setOverlayPlacement(this._targetEl);
        }
      }
    }
    _addScrollResizeObservers() {
      this._addScrollListeners();
      window.addEventListener('resize', this._windowResizeListener);
      this._resizeObserver.observe(this._attachNode);
    }

    _removeScrollResizeObservers(
      attachNode = null,
      removeWindowResizeEventListener = true,
      removeResizeObserver = true,
      removeScrollListeners = true
    ) {
      if (removeWindowResizeEventListener) {
        window.removeEventListener('resize', this._windowResizeListener);
      }
      if (removeScrollListeners) {
        this._removeScrollListeners();
      }
      if (removeResizeObserver) {
        if (attachNode) {
          this._resizeObserver.unobserve(attachNode);
        } else if (this._attachNode) {
          this._resizeObserver.unobserve(this._attachNode);
        }
      }
      this._resizeObserver.disconnect();
    }

    disconnectedCallback() {
      this._removeScrollResizeObservers();
      if (this._invokerNode) {
        this._doSomethingWithOldInvokerNode(this._invokerNode);
      }
      super.disconnectedCallback();
    }
    _resizeObserverActions() {
      requestAnimationFrame(() => {
        this._positionOverlayIfPossible();
      });
    }
    _windowResizeActions() {
      requestAnimationFrame(() => {
        this._positionOverlayIfPossible();
      });
    }
    _addScrollListeners() {
      if (this._rootNodes.length === 0) {
        this._rootNodes = [];
        // Listen for scroll events in all shadowRoots hosting this overlay only
        // when in native ShadowDOM.
        let node = this._attachNode;
        while (node) {
          if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && node.host) {
            this._rootNodes.push(node);
          }
          node = node.host || node.assignedSlot || node.parentNode;
        }
        this._rootNodes.push(document);
        this._rootNodes.forEach((el) => {
          el.addEventListener('scroll', this._onParentScroll, {
            capture: true,
            passive: true,
          });
        });
      }
    }
    _parentScrollActions() {
      requestAnimationFrame(() => {
        if (this.scrollAction === 'refit' && this.visible) {
          this._positionOverlayIfPossible();
        } else if (
          (this.scrollAction === 'cancel' || this.scrollAction === 'hide') &&
          this.visible
        ) {
          this.visible = false;
        }
      });
    }
    _removeScrollListeners() {
      this._rootNodes.forEach((el) => {
        el.removeEventListener('scroll', this._onParentScroll, {
          capture: true,
          passive: true,
        });
      });
      this._rootNodes = [];
    }
    // can be overriden in implementing components
    _setOverlayPlacement(attachNode) {
      console.log(`Please use this function in the implementing components with ${attachNode}`);
    }
    // can be overriden in implementing components
    _canPositionOverlay() {
      return this.visible && this._attachNode && !this.mobile;
    }
    // can be overriden in implementing components
    _positionOverlayIfPossible() {
      if (this._canPositionOverlay()) {
        this._setOverlayPlacement(this._attachNode);
      }
    }
    // can be overriden in implementing components
    _doSomethingWithNewInvokerNode(invokerNode) {
      console.log(`Please use this function in the implementing components with ${invokerNode}`);
    }
    // can be overriden in implementing components
    _doSomethingWithOldInvokerNode(invokerNode) {
      console.log(`Please use this function in the implementing components with ${invokerNode}`);
    }
  };
